import React from "react";
import cx from "classnames";
import HelpTooltip from "../HelpTooltip";

const ControlLabel = ({
  text,
  children,
  baseClassName = "si-c-label",
  className,
  tooltip,
  ...otherProps
}) => (
  <label className={cx(baseClassName, className)} {...otherProps}>
    {tooltip ? (
      <HelpTooltip baseClassName="si-c-property-input__help" trigger="click" tooltipKey={tooltip}>
        <>
          {text}
          {children}
        </>
      </HelpTooltip>
    ) : (
      <>
        {text} {children}
      </>
    )}
  </label>
);
export default ControlLabel;
